import React from "react";
import { ProgressBar, Step } from "react-step-progress-bar";
import PropTypes from 'prop-types';

import "react-step-progress-bar/styles.css";
import "./DSGProgressBar.css";

export default class DSGProgressBar extends React.Component {
  render() {
    const { totalPages, currentPage, navigateToPage } = this.props;
    const percent = (((currentPage) / (totalPages + 2)) * 100) + .75;

    const steps = [
      <Step key={'start'} transition="scale">
        {({ accomplished }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : ""} ${currentPage === 0 ? "currentStep" : ""}`}
            onClick={() => navigateToPage(0)}
          >
            {0}
          </div>
        )}
      </Step>,
      ...Array.from({ length: totalPages }, (_, i) => (
        <Step key={i} transition="scale">
          {({ accomplished, index }) => (
            <div
              className={`indexedStep ${accomplished ? "accomplished" : ""} ${currentPage === index ? "currentStep" : ""}`}
              onClick={() => navigateToPage(i + 1)}
            >
              {i + 1}
            </div>
          )}
        </Step>
      )),
      <Step key={'almost-end'} transition="scale">
        {({ accomplished }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : ""}  ${currentPage === totalPages + 1 ? "currentStep" : ""}`}
            onClick={() => navigateToPage(totalPages + 1)}
          >
            {'X'}
          </div>
        )}
      </Step>,
      <Step key={'end'} transition="scale">
        {({ accomplished }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : ""}  ${currentPage === totalPages + 2 ? "currentStep" : ""}`}
            onClick={() => navigateToPage(totalPages + 2)}
          >
            {'Ende'}
          </div>
        )}
      </Step>
    ];

    return (
      <ProgressBar
        percent={percent}
        filledBackground="linear-gradient(to right, #F7F4F3, #BDD4E1)"
      >
        {steps}
      </ProgressBar>
    );
  }
}

DSGProgressBar.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
};